// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__KWx4n","logoCollapsed":"logo_logoCollapsed__Y2GVo","overrideColor":"logo_overrideColor__bgT-W","image":"logo_image__WjW9r"};